module.exports = __webpack_public_path__ + "img/footscan-feet.3f46d925.svg";